export { default } from './BlueCorner';
